<nz-modal
  [(nzVisible)]="visible"
  [nzTitle]="'builderScreen.presets.title' |translateTA"
  [nzFooter]="null"
  [nzWidth]="600"
  nzCentered
  (nzOnCancel)="onClose()">
  
  <!-- Conteúdo do Modal -->
  <div class="presets-modal-content">
    
          <!-- Cabeçalho do Tipo de Componente -->
    <div class="component-type-header" *ngIf="componentType">
      <nz-tag [nzColor]="'blue'">
        {{ ('builderScreen.componentTypes.' + (componentType || 'unknown')) |translateTA }}
      </nz-tag>
      <span class="component-type-label">
        {{ 'builderScreen.presets.availableFor' |translateTA }}
      </span>
    </div>

          <!-- Grade de Presets -->
    <div class="presets-grid" *ngIf="presets$ | async as presets; else noPresets">
      <nz-card 
        *ngFor="let preset of presets; trackBy: trackByPresetId"
        class="preset-card"
        [class.active]="selectedPreset?.id === preset.id"
        [class.selectable]="true"
        (click)="selectPreset(preset)"
        nzHoverable>
        
                  <!-- Prévia do Preset -->
        <div class="preset-preview">
          <div class="preview-icon">
            <nz-icon [nzType]="preset.icon || 'setting'" nzTheme="outline"></nz-icon>
          </div>
        </div>
        
                  <!-- Informações do Preset -->
        <div class="preset-info">
          <h4 class="preset-name">{{ preset.name }}</h4>
          <p class="preset-description">{{ preset.description }}</p>
          
          <!-- Tags do Preset -->
          <div class="preset-tags" *ngIf="preset.tags && preset.tags.length > 0">
            <nz-tag 
              *ngFor="let tag of preset.tags" 
              nzSize="small"
              [nzColor]="'default'">
              {{ tag }}
            </nz-tag>
          </div>
          
          <!-- Indicador de Popularidade -->
          <div class="preset-popularity" *ngIf="preset.popularity">
            <nz-rate 
              [ngModel]="preset.popularity / 20" 
              nzDisabled 
              nzAllowHalf
              [nzCount]="5">
            </nz-rate>
            <small class="popularity-text">Popular</small>
          </div>
        </div>

                  <!-- Indicador de Seleção -->
        <div class="selection-indicator" *ngIf="selectedPreset?.id === preset.id">
          <nz-icon nzType="check-circle" nzTheme="fill" style="color: #52c41a;"></nz-icon>
        </div>
      </nz-card>
    </div>

          <!-- Estado Sem Presets -->
    <ng-template #noPresets>
      <div class="no-presets-state">
        <nz-empty
          nzNotFoundImage="simple"
          [nzNotFoundContent]="'builderScreen.presets.noPresets' |translateTA">
          <div nz-empty-footer>
            <button 
              nz-button 
              nzType="primary" 
              (click)="createPresetFromCurrent()"
              *ngIf="selectedNode">
              {{ 'builderScreen.presets.create' |translateTA }}
            </button>
          </div>
        </nz-empty>
      </div>
    </ng-template>

          <!-- Ações do Modal -->
    <div class="preset-actions">
      <div class="action-group secondary">
        <button 
          nz-button 
          nzType="default"
          (click)="createPresetFromCurrent()"
          *ngIf="selectedNode">
          <nz-icon nzType="plus" nzTheme="outline"></nz-icon>
          {{ 'builderScreen.presets.create' |translateTA }}
        </button>
      </div>
      
      <div class="action-group primary">
        <button 
          nz-button 
          nzType="primary" 
          (click)="applyPreset()"
          [disabled]="!selectedPreset">
          <nz-icon nzType="check" nzTheme="outline"></nz-icon>
          {{ 'builderScreen.presets.apply' |translateTA }}
        </button>
        
        <button 
          nz-button 
          nzType="default" 
          (click)="onClose()">
          {{ 'builderScreen.actions.cancel' |translateTA }}
        </button>
      </div>
    </div>
  </div>
</nz-modal>
